import styled from 'styled-components'
import { flexCenterMixin, disableSomeContentStyles } from 'styles/mixins'
import { TTS_ACTIVE_ITEM_BACKGROUND_PADDING } from '../Item/consts'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const TextToSpeechAddButtonWrapper = styled.div<{
  $isDisabled: boolean
}>`
  margin: 3px 4px 0;
  position: relative;
  width: calc(100% - ${TTS_ACTIVE_ITEM_BACKGROUND_PADDING * 2}px);
  height: 20px;
  ${flexCenterMixin()}

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background: ${COLORS.borderColor};
  }

  ${({ $isDisabled }) => $isDisabled && disableSomeContentStyles()}

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin-top: 12px;
  }
`

export const AddCircleButton = styled.button`
  width: 20px;
  height: 20px;
  ${flexCenterMixin()}
  background: ${COLORS.white};
  border-radius: 50%;
  border: 1px solid ${COLORS.borderColor};
  z-index: 1;
  cursor: pointer;

  @media screen and (min-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    &:hover {
      background: ${COLORS.primaryLight};

      path {
        fill: ${COLORS.secondaryDark};
      }
    }
  }

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 32px;
    height: 32px;
  }
`
